export const translationsObject: {
    [languageCode: string]: { [languageName: string]: string };
} = {
    en: {
        languageName: 'English',
    },
    no: {
        languageName: 'Norsk',
    },
    da: {
        languageName: 'Dansk',
    },
    sv: {
        languageName: 'Svensk',
    },
};
